import React from "react";
import clipboardCopy from "clipboard-copy";

import { getStripeDate } from "../../../../utils/format-stripe-date";
import { formatNumber } from "../../../../utils/format-sub";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import Avatar from "../../../../parts/avatar";
import ToolTip from "../../../../parts/tooltip";
import SvgIcon from "../../../../parts/SvgIcon";

const PaymentsTable = ({ payments, sorting, handleSort, theme }) => {
  const sortedPayments =
    sorting === "desc" ? payments : [...payments].reverse();

  return (
    <div className="payments-history">
      <header>
        <h3 className="title">Payments history</h3>
      </header>
      <section role="table-wrapper" data-borders-inside>
        <table role="report-table">
          <thead>
            <tr>
              <th>Subscriber</th>
              <th>
                <div className="flex gap-2">
                  Date
                  <SvgIcon
                    src="/img/svg/up_down_arrows.svg"
                    onClickFn={handleSort}
                  />
                </div>
              </th>
              <th className="subscriber-th">Amount</th>
            </tr>
          </thead>
          <tbody>
            {sortedPayments.map(
              ({
                total,
                name,
                avatar,
                created,
                customer_email,
                currency,
                id,
              }) => {
                const { day, month, year } = getStripeDate(created);
                return (
                  <tr key={id}>
                    <td
                      className="subscriber-td"
                      onClick={() => clipboardCopy(customer_email)}
                      style={{ cursor: "copy" }}
                    >
                      <ToolTip
                        id={id}
                        body={`Click to copy email ${customer_email}`}
                      >
                        <div className="flex gap-2 items-center">
                          <div className="image-wrapper">
                            {name ? (
                              <img
                                src={getAvatarUrl(
                                  { name, avatar },
                                  null,
                                  theme
                                )}
                                className="w-8 h-8 rounded-full"
                                alt="avatar"
                              />
                            ) : (
                              <img
                                style={{
                                  width: 32,
                                  height: 32,
                                  borderRadius: 32,
                                }}
                                src="/img/avatars/registration-pending2.svg"
                                className="icon-grey"
                              ></img>
                            )}
                          </div>
                          <span className="subscriber-text">
                            {name || customer_email}
                          </span>
                        </div>
                      </ToolTip>
                    </td>
                    <td>{`${month} ${day}, ${year}`}</td>
                    <td className="amount">{formatNumber(total, currency)}</td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default React.memo(PaymentsTable);
